import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { Action, Reducer } from "redux"
import { IReportsCampaignResult } from "reports/model"
import { ICampaign, ICampaignState } from "../model"
import {
  ICampaignActionDuplicatePopup,
  ICampaignActionSetList,
  ICampaignActionSetListDspDeal,
  ICampaignActionSetListEstimates,
  ICampaignActionSetListReports
} from "./actions"
import { getDefaultCampaignState } from "./state"

export const campaignReducer: Reducer<ICampaignState, Action> = (
  state: ICampaignState | undefined,
  action: Action
): ICampaignState => {
  if (!state) {
    state = getDefaultCampaignState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { statuses, types } = action as IAppActionInitData
      return {
        ...state,
        statuses,
        types
      }
    }

    case ACTIONS.CAMPAIGN_SET_LIST: {
      const { isForecast, isDspDeal, list } = action as ICampaignActionSetList
      return {
        ...state,
        campaignList: isForecast || isDspDeal ? state.campaignList : { ...state.campaignList, ...list },
        forecastList: isForecast ? { ...state.forecastList, ...list } : state.forecastList,
        dspDealList: isDspDeal ? { ...state.dspDealList, ...list } : state.dspDealList
      }
    }

    case ACTIONS.CAMPAIGN_DUPLICATE_POPUP: {
      const { duplicatePopup } = action as ICampaignActionDuplicatePopup
      return {
        ...state,
        duplicatePopup: {
          ...state.duplicatePopup,
          ...duplicatePopup
        }
      }
    }

    case ACTIONS.CAMPAIGN_SET_LIST_REPORTS: {
      const { reports } = action as ICampaignActionSetListReports
      const reportsByCampaignId: { [campaignId: number]: IReportsCampaignResult } = {}
      for (const report of reports) {
        if (report.campaign_id) {
          reportsByCampaignId[report.campaign_id] = report
        }
      }
      return {
        ...state,
        campaignList: {
          ...state.campaignList,
          filteredEntities: state.campaignList.filteredEntities.map(
            c =>
              ({
                ...c,
                reports: reportsByCampaignId[c.id] || null
              }) as ICampaign
          ),
          isLoadingReports: false
        }
      }
    }

    case ACTIONS.CAMPAIGN_SET_LIST_ESTIMATES: {
      const { isForecast, isDspDeal, estimates } = action as ICampaignActionSetListEstimates
      if (isForecast) {
        return {
          ...state,
          forecastList: {
            ...state.forecastList,
            filteredEntities: state.forecastList.filteredEntities.map(c => ({
              ...c,
              estimate: estimates[c.id] || null
            })),
            isLoadingEstimates: false
          }
        }
      }
      if (isDspDeal) {
        return {
          ...state,
          dspDealList: {
            ...state.dspDealList,
            filteredEntities: state.dspDealList.filteredEntities.map(c => ({
              ...c,
              estimate: estimates[c.id] || null
            })),
            isLoadingEstimates: false
          }
        }
      }
      return {
        ...state,
        campaignList: {
          ...state.campaignList,
          filteredEntities: state.campaignList.filteredEntities.map(c => ({
            ...c,
            estimate: estimates[c.id] || null
          })),
          isLoadingEstimates: false
        }
      }
    }

    case ACTIONS.CAMPAIGN_SET_LIST_DSP_DEALS: {
      const { dspDealByCampaignId } = action as ICampaignActionSetListDspDeal
      return {
        ...state,
        dspDealList: {
          ...state.dspDealList,
          filteredEntities: state.dspDealList.filteredEntities.map(c => ({
            ...c,
            dspDeal: dspDealByCampaignId[c.id] || null
          })),
          isLoadingDspDeal: false
        }
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultCampaignState()
    }

    default:
      return state
  }
}
